import { Section } from '../types';
import { getSafetyNotesForSection, getEvaluationKeyPoints } from '../utils/safetyKeyPoints';

export const quizSections: Section[] = [
  {
    id: 'general-safety',
    name: 'General Safety',
    description: 'Basic safety protocols and procedures for workshop environments',
    order: 1,
    safetyNotes: getSafetyNotesForSection('general-safety'),
    questions: [
      {
        id: 'gs_001',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Always wear eye ______ when at the shop.',
        options: ['Protection', 'Drops', 'Makeup', 'Contacts'],
        correct: 0,
        explanation: 'Always wear eye protection. Wear safety glasses, goggles or a face shield.'
      },
      {
        id: 'gs_002',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Use equipment only with the instructor\'s ______.',
        options: ['Protection', 'Permission', 'Assistance', 'Supervision'],
        correct: 1,
        explanation: 'Get the instructor\'s permission before you use the equipment.'
      },
      {
        id: 'gs_003',
        section: 'general-safety',
        type: 'multiple-choice',
        question: '______ all accidents or injuries.',
        options: ['Ignore', 'Report', 'Document', 'Hide'],
        correct: 1,
        explanation: 'Report all accidents, near accidents, or injuries to the instructor immediately.'
      },
      {
        id: 'gs_004',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Do not use ______ equipment.',
        options: ['Defective', 'Clean', 'New', 'Heavy'],
        correct: 0,
        explanation: 'Don\'t use tools or equipment that are in any way defective.'
      },
      {
        id: 'gs_005',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Never use equipment until you have been properly ______ in its use.',
        options: ['Trained', 'Protected', 'Supervised', 'Tested'],
        correct: 0,
        explanation: 'Don\'t use any equipment until you have been shown how to use it correctly and safely.'
      },
      {
        id: 'gs_006',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Loose clothing can cause ______.',
        options: ['Protection', 'Injuries', 'Comfort', 'Warmth'],
        correct: 1,
        explanation: 'Loose clothing can get caught in a machine and cause an injury.'
      },
      {
        id: 'gs_007',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Long hair must be ______ or covered with a cap.',
        options: ['Tied back', 'Braided', 'Cut short', 'Washed'],
        correct: 0,
        explanation: 'If your hair is long, tie it back or wear a cap over it.'
      },
      {
        id: 'gs_008',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Wear ______ shoes or boots.',
        options: ['Closed-toed', 'Canvas', 'Open-toed', 'High-heeled'],
        correct: 0,
        explanation: 'Wear protective shoes. Wear hard shoes or boots with rubber soles and rubber heels.'
      },
      {
        id: 'gs_009',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Approved protection earmuffs should be worn around ______ equipment.',
        options: ['Dirty', 'Noisy', 'Clean', 'Small'],
        correct: 1,
        explanation: 'Wear approved ear protection around loud, noisy equipment.'
      },
      {
        id: 'gs_010',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'A ______ must be worn when working where there is wood dust.',
        options: ['Dust mask', 'Face shield', 'Hard hat', 'Apron'],
        correct: 0,
        explanation: 'Wear a dust mask or an air filter when working around a lot of wood dust.'
      },
      {
        id: 'gs_011',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Always ______ spilled materials.',
        options: ['Ignore', 'Clean up', 'Mark', 'Avoid'],
        correct: 1,
        explanation: 'Clean up spills. Don\'t leave anything on the floor that someone could slip on.'
      },
      {
        id: 'gs_012',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Locate the ______ and learn how to use them.',
        options: ['Fire extinguishers', 'Air hoses', 'Light switches', 'Tool cabinets'],
        correct: 0,
        explanation: 'Know where the fire extinguishers are located and know how to use them before there is an emergency.'
      },
      {
        id: 'gs_013',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Keep cabinet doors and drawers ______.',
        options: ['Open', 'Closed', 'Locked', 'Labeled'],
        correct: 1,
        explanation: 'Keep cabinet doors and drawers closed.'
      },
      {
        id: 'gs_014',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Never leave anything on the ______ that could be slipped on or tripped over.',
        options: ['Floor', 'Workbench', 'Wall', 'Ceiling'],
        correct: 0,
        explanation: 'Don\'t leave anything on the floor that could be tripped over or slipped on.'
      },
      {
        id: 'gs_015',
        section: 'general-safety',
        type: 'multiple-choice',
        question: '______ vises when they are not in use.',
        options: ['Open', 'Close', 'Oil', 'Clean'],
        correct: 1,
        explanation: 'Vises should be kept closed when they\'re not in use.'
      },
      {
        id: 'gs_016',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Workbenches should be kept ______ and organized.',
        options: ['Clear', 'Cluttered', 'Full', 'Messy'],
        correct: 0,
        explanation: 'Keep workbenches clear and organized.'
      },
      {
        id: 'gs_017',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Use ______ to clear away scraps and sawdust.',
        options: ['Your hands', 'A brush', 'Your sleeve', 'Nothing'],
        correct: 1,
        explanation: 'Always use a brush or a rag to clear away sawdust and scraps. Never use your hands.'
      },
      {
        id: 'gs_018',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Tools should be used only for what they are ______ to do.',
        options: ['Designed', 'Easiest', 'Fun', 'Quick'],
        correct: 0,
        explanation: 'Use the right tool for the job. Use the tool only for what its designed to do.'
      },
      {
        id: 'gs_019',
        section: 'general-safety',
        type: 'multiple-choice',
        question: '______ should be removed before you do any work in the shop.',
        options: ['Safety equipment', 'Dangling Jewelry', 'Shoes', 'Gloves'],
        correct: 1,
        explanation: 'Remove rings, watches, bracelets, and necklaces.'
      },
      {
        id: 'gs_020',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'A tool should always be held by the ______.',
        options: ['Cord', 'Handle', 'Blade', 'Weight'],
        correct: 1,
        explanation: 'When you hold a tool, hold it by the handle.'
      },
      {
        id: 'gs_021',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'When you are finished with a tool, return it to its ______.',
        options: ['Assigned storage area', 'Where you found it', 'Nearest location', 'Friend'],
        correct: 0,
        explanation: 'When you\'re finished with a tool, return it to its proper storage area.'
      },
      {
        id: 'gs_022',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Ask for ______ when you need to handle large or heavy material.',
        options: ['Permission', 'Help', 'Time', 'Tools'],
        correct: 1,
        explanation: 'If you\'re handling large or heavy materials, get someone to help you.'
      },
      {
        id: 'gs_023',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Lift with your ______ not with your back.',
        options: ['Neck', 'Legs', 'Arms', 'Shoulders'],
        correct: 1,
        explanation: 'Lift with your legs, not with your back.'
      },
      {
        id: 'gs_024',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Never handle ______ equipment if your hands are wet or if you are standing on a wet floor.',
        options: ['Electrical', 'Writing', 'Metal', 'Wooden'],
        correct: 0,
        explanation: 'Be sure your hands are dry and that you\'re standing on a dry floor when you use electrical devices.'
      },
      {
        id: 'gs_025',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Equipment with a ______ power cord should be reported to the instructor. It should not be used.',
        options: ['Damaged', 'Clean', 'Long', 'Short'],
        correct: 0,
        explanation: 'Don\'t use the equipment if the insulation on the cord is damaged, cut, or frayed.'
      },
      {
        id: 'gs_026',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Don\'t yank on the power cord to disconnect a tool. Pull the ______.',
        options: ['Plug', 'Socket', 'Wire', 'Switch'],
        correct: 0,
        explanation: 'When you disconnect a power cord, pull the plug; don\'t yank on the cord.'
      },
      {
        id: 'gs_027',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Use all the recommended ______ and other safety devices when you operate power equipment.',
        options: ['Guards', 'Obstructions', 'Decorations', 'Colors'],
        correct: 0,
        explanation: 'Use all the recommended guards and safety devices on the power equipment.'
      },
      {
        id: 'gs_028',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Always disconnect power equipment before performing ______.',
        options: ['Routine operations', 'Any maintenance, cleaning, or adjustments', 'Major adjustments only', 'Minor adjustments only'],
        correct: 1,
        explanation: 'Always disconnect power equipment before performing any maintenance, cleaning, or adjustments.'
      },
      {
        id: 'gs_029',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Before making any adjustments to equipment, you must ensure it is ______.',
        options: ['Warmed up', 'Completely stopped', 'Recently serviced', 'Running smoothly'],
        correct: 1,
        explanation: 'Never adjust equipment while it\'s running. Always wait for equipment to come to a complete stop before making any adjustments, and verify the previous user has properly shut it down.'
      },
      {
        id: 'gs_030',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Safe equipment operation requires your complete ______.',
        options: ['Strength', 'Attention', 'Training', 'Time'],
        correct: 1,
        explanation: 'Using tools and equipment requires your complete attention and concentration. Never talk to or distract anyone while they are operating equipment, as this can lead to serious accidents.'
      },
      {
        id: 'gs_031',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Always work at a ______ speed.',
        options: ['Fast', 'Safe', 'Slow', 'Variable'],
        correct: 1,
        explanation: 'Work at a safe speed. Don\'t rush or hurry through a project.'
      },
      {
        id: 'gs_032',
        section: 'general-safety',
        type: 'multiple-choice',
        question: 'Never fool around or ______ in the shop.',
        options: ['Run around', 'Concentrate', 'Learn', 'Work'],
        correct: 0,
        explanation: 'Work at a safe speed. Don\'t rush or hurry through a project. Working too fast is dangerous.'
      }
    ]
  },
  {
    id: 'hand-tools',
    name: 'Hand Tool Safety',
    description: 'Safe use and maintenance of manual tools and equipment',
    order: 2,
    safetyNotes: getSafetyNotesForSection('hand-tools'),
    questions: [
      {
        id: 'ht_001',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'Use only the type of hand tools that are ______ for the work you are doing.',
        options: ['Defective', 'Designed', 'Borrowed', 'Expensive'],
        correct: 1,
        explanation: 'Always use the right type of hand tool for the job. Use the tool designed for the specific work you want to do.'
      },
      {
        id: 'ht_002',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'Always use the right ______ hand tool for the job.',
        options: ['Size', 'Small', 'Heavy', 'Brand'],
        correct: 0,
        explanation: 'Use the right size hand tool. Don\'t try to do heavy work with a small tool or fine work with heavy-duty tools.'
      },
      {
        id: 'ht_003',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'Check hand tools to be sure they are sharp, ______ and in good condition before you use them.',
        options: ['Clean', 'Large', 'Old', 'Heavy'],
        correct: 0,
        explanation: 'Before you use a hand tool, check it to be sure it\'s clean and in good condition.'
      },
      {
        id: 'ht_004',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'Don\'t use your ______ to test whether or not a tool is sharp.',
        options: ['Finger', 'Shirt', 'Wood', 'Eyes'],
        correct: 0,
        explanation: 'Never use your hands or fingers to test whether or not a tool is sharp. You\'ll cut yourself.'
      },
      {
        id: 'ht_005',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'Be sure the hand tool handle is fitted ______ and securely.',
        options: ['Loosely', 'Tightly', 'Temporarily', 'Backwards'],
        correct: 1,
        explanation: 'Be sure the hand tool handle is fitted tightly and securely.'
      },
      {
        id: 'ht_006',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'Don\'t use a hand tool that is ______. Inspect hand tools carefully before use.',
        options: ['Dull, Broken or Defective', 'Borrowed or Shared', 'Sharp or Clean', 'New or Expensive'],
        correct: 0,
        explanation: 'Don\'t use a dull, broken, or defective hand tool. Report defective or damaged hand tools to the instructor immediately.'
      },
      {
        id: 'ht_007',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'The material should be fastened down so that ______ hands are left free to use the hand tools.',
        options: ['Both', 'No', 'One', 'Three'],
        correct: 0,
        explanation: 'Fasten the work down so you\'ll have both hands to use the tools.'
      },
      {
        id: 'ht_008',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'To safely operate hand tools, you should always plan the work so that you can keep your ______.',
        options: ['Schedule clear', 'Balance steady', 'Phone nearby', 'Windows open'],
        correct: 1,
        explanation: 'Plan the work so you can keep your balance. Always keep your weight on both feet, and don\'t over-reach when using hand tools.'
      },
      {
        id: 'ht_009',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'Never lay hand tools down near the ______ of the bench where they could roll off or where someone could bump into them.',
        options: ['Edge', 'Center', 'Back', 'Left'],
        correct: 0,
        explanation: 'Don\'t lay hand tools down near the edge of the bench where they could roll off or where someone could bump into them.'
      },
      {
        id: 'ht_010',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: '______ aim a cutting hand tool toward you or toward anyone else.',
        options: ['Never', 'Always', 'Sometimes', 'Carefully'],
        correct: 0,
        explanation: 'Never aim a cutting hand tool toward your hands, arms, or body. Aim the tool away from you and away from others.'
      },
      {
        id: 'ht_011',
        section: 'hand-tools',
        type: 'multiple-choice',
        question: 'Keep your hands and arms ______ the cutting edge of the hand tool.',
        options: ['Near', 'Away from', 'Under', 'Around'],
        correct: 1,
        explanation: 'Always keep your hands and arms out of the path of a cutting hand tool. Keep hands and arms behind the cutting edge.'
      },
    ]
  },
  {
    id: 'portable-power-tools',
    name: 'Portable Power Tool Safety',
    description: 'Safe operation of handheld power tools and electrical safety practices',
    order: 3,
    safetyNotes: getSafetyNotesForSection('portable-power-tools'),
    questions: [      {
        id: 'ppt_001',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'The instructor must be ______ when you use power equipment.',
        options: ['Present in the shop', 'Outside', 'Sleeping', 'At Dairy Queen'],
        correct: 0,
        explanation: 'Use power tools only when the instructor is present in the shop.'
      },
      {
        id: 'ppt_002',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'The blades, knives or bits used with power tools must be ______ and in good condition.',
        options: ['Sharp', 'Dull', 'Large', 'Small'],
        correct: 0,
        explanation: 'The tool must be sharp and in good condition. Check the blade, knives, or bit to make sure that they are sharp and in good condition.'
      },
      {
        id: 'ppt_003',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'Use power tools only for what it was designed to do, and don\'t force the tool or ______ it.',
        options: ['Enjoy', 'Overload', 'Clean', 'Store'],
        correct: 1,
        explanation: 'Don\'t over load or force a portable power tool. Use it only for what it was designed to do.'
      },
      {
        id: 'ppt_004',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'Electric power tools must be ______ or double insulated to prevent a possible shock.',
        options: ['Uninsulated', 'Grounded', 'Portable', 'Heavy'],
        correct: 1,
        explanation: 'Electrical power tools must be grounded or double insulated to prevent a possible electric shock.'
      },
      {
        id: 'ppt_005',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'Power tools should be ______ only while they are in use.',
        options: ['Plugged in', 'Disconnected', 'Stored', 'Cleaned'],
        correct: 0,
        explanation: 'Keep the tool disconnected when it is not in use. Plug it in when you are ready to use the tool.'
      },
      {
        id: 'ppt_006',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'Be sure the switch is in the ______ position before you plug in the power tool.',
        options: ['Off', 'On', 'Middle', 'Auto'],
        correct: 0,
        explanation: 'Check the switch before you plug in the tool. Always check the switch first to make sure it\'s in the \'off\' position.'
      },
      {
        id: 'ppt_007',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'Keep the ______ out of the path of the tool.',
        options: ['Power cord', 'Material', 'Snacks', 'Dust'],
        correct: 0,
        explanation: 'Keep the power cord well out of the way when the tool is operating. Keep the cord out of the path of the tool.'
      },
      {
        id: 'ppt_008',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'The power tool must be ______ before making any changes or adjustments on the tool.',
        options: ['Powered Down', 'Plugged in', 'Running', 'Warm'],
        correct: 0,
        explanation: 'Always disconnect the tool before you make any changes or adjustments. Don\'t make any changes or adjustments while the tool is plugged in.'
      },
      {
        id: 'ppt_009',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'The material you are working on should be ______.',
        options: ['Loose', 'Fastened down', 'Moving', 'Wet'],
        correct: 1,
        explanation: 'Fasten the work down. Avoid holding the work with one hand and operating the tool with the other hand.'
      },
      {
        id: 'ppt_010',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'Hold the tool firmly so you always have ______ of it.',
        options: ['Control', 'Feel', 'Sight', 'Sound'],
        correct: 0,
        explanation: 'Hold the tool firmly. It may twist when you turn it on. Hold the tool so you always have control of it.'
      },
      {
        id: 'ppt_011',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'Be sure the tool is running at ______ before you start the cut.',
        options: ['Slow speed', 'Full speed', 'Half speed', 'Variable speed'],
        correct: 1,
        explanation: 'Wait until the tool comes up to full speed before you start the cut.'
      },
      {
        id: 'ppt_012',
        section: 'portable-power-tools',
        type: 'multiple-choice',
        question: 'Don\'t let anything distract you. Pay ______ to what you are doing so you can do it safely at all times.',
        options: ['Attention', 'Distract', 'Little attention', 'Some attention'],
        correct: 0,
        explanation: 'Using a power tool will require all your attention. Don\'t let anyone distract you. Keep your attention on what you are doing.'
      }
    ]
  },
  {
    id: 'power-equipment',
    name: 'Power Equipment Safety',
    description: 'Safe operation of stationary power equipment and machinery',
    order: 4,
    safetyNotes: getSafetyNotesForSection('power-equipment'),
    questions: [
      {
        id: 'pe_001',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Don\'t use power equipment until you have been shown how to use it ______ and safely.',
        options: ['Quickly', 'Correctly', 'Roughly', 'Slowly'],
        correct: 1,
        explanation: 'Don\'t use power equipment until you have been shown how to use it correctly and safely.'
      },      {
        id: 'pe_002',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Check to be sure the power equipment is in ______ condition before you use it.',
        options: ['Poor', 'Good', 'Any', 'Working'],
        correct: 1,
        explanation: 'Check to be sure the power equipment is in good condition before you use it.'
      },
      {
        id: 'pe_003',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Be sure that all ______ and safety devices are in place before operating the machine.',
        options: ['Guards', 'Tools', 'Materials', 'People'],
        correct: 0,
        explanation: 'Be sure the machine is ready to operate. Check to see that all the guards and safety devices are in place.'
      },
      {
        id: 'pe_004',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Check to be sure that all cutting tools are ______ and properly installed.',
        options: ['Dull', 'Sharp', 'Large', 'Small'],
        correct: 1,
        explanation: 'Check the power equipment to be sure it\'s clean and that all cutting tools are sharp and properly installed.'
      },
      {
        id: 'pe_005',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Check to be sure that clamps, fences, and all adjustment devices are ______.',
        options: ['Loose', 'Tight', 'Missing', 'Broken'],
        correct: 1,
        explanation: 'Check to be sure that clamps, fences, and all other adjustment devices are tight.'
      },
      {
        id: 'pe_006',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Check to be sure that wrenches and adjustment tools have been ______ from the machine.',
        options: ['Attached to', 'Removed', 'Tightened on', 'Left on'],
        correct: 1,
        explanation: 'Check to be sure that wrenches and adjustment tools have been removed from the machine.'
      },
      {
        id: 'pe_007',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Be sure your hands are ______ when you operate electrical equipment.',
        options: ['Wet', 'Dry', 'Clean', 'Protected'],
        correct: 1,
        explanation: 'Be sure your hands are dry and that you\'re standing on a dry floor when you operate electrical equipment.'
      },
      {
        id: 'pe_008',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Feed the work into the machine at a ______ rate.',
        options: ['Fast', 'Steady', 'Variable', 'Slow'],
        correct: 1,
        explanation: 'Feed the work into the machine at a steady rate. Don\'t force the work through the machine faster than it will cut easily.'
      },
      {
        id: 'pe_009',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Keep your hands ______ from the cutting tools at all times.',
        options: ['Close to', 'Away', 'Near', 'Above'],
        correct: 1,
        explanation: 'Keep your hands away from the cutting tools at all times.'
      },
      {
        id: 'pe_010',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Use a push stick or push ______ to keep your hands away from the danger area.',
        options: ['Block', 'Tool', 'Stick', 'Guard'],
        correct: 0,
        explanation: 'Use a push stick or push block to keep your hands away from the danger area.'
      },
      {
        id: 'pe_011',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'If the work gets stuck, ______ the machine and wait for it to stop.',
        options: ['Speed up', 'Turn off', 'Reverse', 'Shake'],
        correct: 1,
        explanation: 'If the work gets stuck, turn off the machine and wait for it to stop before you remove the work.'
      },
      {
        id: 'pe_012',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: '______ the power any time you change cutting tools.',
        options: ['Reduce', 'Disconnect', 'Increase', 'Maintain'],
        correct: 1,
        explanation: 'Disconnect the power any time you change cutting tools.'
      },
      {
        id: 'pe_013',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Keep the ______ around the power equipment clean.',
        options: ['Floor', 'Ceiling', 'Walls', 'Windows'],
        correct: 0,
        explanation: 'Keep the floor around the power equipment clean. Clean up any scraps or sawdust on the floor.'
      },
      {
        id: 'pe_014',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Don\'t ______ to anyone who is operating power equipment.',
        options: ['Listen', 'Talk', 'Wave', 'Point'],
        correct: 1,
        explanation: 'Don\'t talk to anyone who is operating power equipment.'
      },
      {
        id: 'pe_015',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Don\'t let anyone ______ you while you are operating power equipment.',
        options: ['Help', 'Distract', 'Watch', 'Guide'],
        correct: 1,
        explanation: 'Don\'t let anyone distract you while you are operating power equipment.'
      },
      {
        id: 'pe_016',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: '______ up around the machine when you are finished.',
        options: ['Speed', 'Clean', 'Lock', 'Cover'],
        correct: 1,
        explanation: 'Clean up around the machine when you are finished. Return all guards to their proper position.'
      },
      {
        id: 'pe_017',
        section: 'power-equipment',
        type: 'multiple-choice',
        question: 'Return all ______ to their proper position when finished.',
        options: ['Tools', 'Guards', 'Materials', 'Workers'],
        correct: 1,
        explanation: 'Clean up around the machine when you are finished. Return all guards to their proper position.'
      }
    ]
  },
  {
    id: 'portable-circular-saw',
    name: 'Portable Circular Saw Safety',
    description: 'Safe operation of portable circular saws, setup procedures, and cutting techniques',
    order: 5,
    safetyNotes: getSafetyNotesForSection('portable-circular-saw'),
    questions: [
      {
        id: 'pcs_001',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'As with any machine, you must wear proper eye protection, pass ALL tests at ______ percent, and have your teacher\'s permission to operate it.',
        options: ['85', '95', '100', '75'],
        correct: 2,
        explanation: 'You must pass ALL tests with 100 percent and have your teacher\'s permission to operate any machine.'
      },
      {
        id: 'pcs_002',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'It ______ important to make sure that all stock is supported and securely clamped down.',
        options: ['Is', 'Is not', 'Might be', 'Sometimes is'],
        correct: 0,
        explanation: 'All stock must be well supported and securely clamped down for safe operation.'
      },
      {
        id: 'pcs_003',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'Adjust the depth of cut to the thickness of the stock (material) plus ______.',
        options: ['1/8 inch', '1/2 inch', '3/4 inch', '1 inch'],
        correct: 0,
        explanation: 'Adjust the depth of cut to the thickness of the stock plus 1/8 inch for safe and complete cutting.'
      },
      {
        id: 'pcs_004',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'Your work area should be ______ before you start cutting.',
        options: ['Clean', 'Dirty', 'Wet', 'Cluttered'],
        correct: 0,
        explanation: 'Your work area should be clean before you start cutting to prevent accidents and ensure proper operation.'
      },
      {
        id: 'pcs_005',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'Check the base and angle adjustments to be sure they are ______.',
        options: ['Loose', 'Tight', 'Removable', 'Broken'],
        correct: 1,
        explanation: 'Check the base and angle adjustments to be sure they are tight for accurate and safe cutting.'
      },
      {
        id: 'pcs_006',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'Always place the base of the saw on the stock you will be cutting. Make sure that the blade ______ actually touching the stock before you turn it on!',
        options: ['Is', 'Is not', 'Might be', 'Should be'],
        correct: 1,
        explanation: 'Make sure the blade is not touching the stock before starting to prevent kickback and ensure control.'
      },
      {
        id: 'pcs_007',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'Advance the saw blade ______ and evenly making sure that it cuts straight through the work.',
        options: ['Slowly', 'Quickly', 'Backwards', 'Randomly'],
        correct: 0,
        explanation: 'Advance the saw blade slowly and evenly to maintain control and ensure straight cuts.'
      },
      {
        id: 'pcs_008',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'You should sit the saw down when the blade has come to a ______ stop!',
        options: ['Half', 'Full', 'Quick', 'Partial'],
        correct: 1,
        explanation: 'Never put the saw down until the blade has come to a complete stop for safety.'
      },
      {
        id: 'pcs_009',
        section: 'portable-circular-saw',
        type: 'multiple-choice',
        question: 'You should ______ the machine to change the blades or to make any kind of adjustments.',
        options: ['Start', 'Stop', 'Unplug', 'Speed up'],
        correct: 2,
        explanation: 'Always unplug the machine to change blades or make adjustments for safety.'
      }
    ]
  },
  {
    id: 'jig-bayonet-saw',
    name: 'Jig/Bayonet Saw Safety',
    description: 'Safe operation of jig/bayonet saws, blade selection, and cutting techniques',
    order: 6,
    safetyNotes: getSafetyNotesForSection('jig-bayonet-saw'),
    questions: [
      {
        id: 'jbs_001',
        section: 'jig-bayonet-saw',
        type: 'multiple-choice',
        question: 'Selecting the correct blade for the stock (material) ______ important.',
        options: ['Is', 'Is not', 'Might be', 'Sometimes is'],
        correct: 0,
        explanation: 'Select the correct blade for the stock (material) and clamp the blade down tightly in the chuck.'
      },
      {
        id: 'jbs_002',
        section: 'jig-bayonet-saw',
        type: 'multiple-choice',
        question: 'You should clamp the blade down ______ in the chuck.',
        options: ['Lightly', 'Tightly', 'Loosely', 'Barely'],
        correct: 1,
        explanation: 'The blade must be clamped down tightly in the chuck to prevent slippage or ejection.'
      },      {
        id: 'jbs_003',
        section: 'jig-bayonet-saw',
        type: 'multiple-choice',
        question: 'Keep a constant and ______ cutting pressure.',
        options: ['Even', 'Uneven', 'Heavy', 'Light'],
        correct: 0,
        explanation: 'Keep a constant and even cutting pressure. Do not force the blade into the work.'
      },
      {
        id: 'jbs_004',
        section: 'jig-bayonet-saw',
        type: 'multiple-choice',
        question: 'You can safely cut ______ curves.',
        options: ['Tight', 'Slight', 'Sharp', 'No'],
        correct: 1,
        explanation: 'Do not attempt to cut curves that are so tight that the blade can be twisted and then broken.'
      }
    ]
  },
  {
    id: 'band-saw',
    name: 'Band Saw Safety',
    description: 'Safe operation of band saws, cutting techniques, and safety protocols',
    order: 7,
    safetyNotes: getSafetyNotesForSection('band-saw'),
    questions: [
      {
        id: 'bs_001',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'Adjust the blade guard to where it is 1/4 inch above the ______ part of the wood that you are cutting.',
        options: ['Lowest', 'Highest', 'Middle', 'Thickest'],
        correct: 1,
        explanation: 'Adjust the blade guard to where it is 1/4 inch above the highest part of the wood for proper protection.'
      },
      {
        id: 'bs_002',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'You ______ use a push stick when cutting using band saw.',
        options: ['Should', 'Should not', 'Never', 'Sometimes'],
        correct: 0,
        explanation: 'Use a push stick whenever possible and always when cutting small objects.'
      },
      {
        id: 'bs_003',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'You should wait ______ for your turn to use the machine.',
        options: ['At McDonalds', 'At a safe distance', 'In the office', 'Very Impatiently'],
        correct: 1,
        explanation: 'Everyone should form a line and wait patiently and quietly behind the yellow line.'
      },
      {
        id: 'bs_004',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'ONLY ______ person(s) can use this machine at a time.',
        options: ['One', 'Three', 'Two', 'Four'],
        correct: 0,
        explanation: 'ONLY one person can use the machine at a time.'
      },
      {
        id: 'bs_005',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'You can SAFELY cut ______ curves on the band saw.',
        options: ['Slight', 'Sharp', 'Tight', 'No'],
        correct: 0,
        explanation: 'Cut sharp curves on the scroll saw. The band saw is better for slight curves.'
      },
      {
        id: 'bs_006',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'You fingers should stay ______ of the blade as you cut.',
        options: ['In front', 'To either side', 'Behind', 'Above'],
        correct: 1,
        explanation: 'Your fingers should be on either side of the blade, but never in front of the blade.'
      },
      {
        id: 'bs_007',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'When cutting round or irregular-shaped stock you should use the ______ to secure it.',
        options: ['C-block', 'V-block', 'Square block', 'Triangle block'],
        correct: 1,
        explanation: 'Round stock must be cut using the V-block to secure it.'
      },
      {
        id: 'bs_008',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'You should use ______ to clean the top of the table off when you are finished.',
        options: ['Hand', 'Table broom', 'Fingers', 'Cloth'],
        correct: 1,
        explanation: 'Clean the table off by using a table broom, never your hands.'
      },
      {
        id: 'bs_009',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'It ______ SAFE to force wood into the blade.',
        options: ['Is', 'Is not', 'Might be', 'Sometimes is'],
        correct: 1,
        explanation: 'Never force your wood into the blade. Let the machine do the work.'
      },
      {
        id: 'bs_010',
        section: 'band-saw',
        type: 'multiple-choice',
        question: 'Blades do occasionally break on this machine. If it does break you should:',
        options: ['Fix it yourself', 'Turn it off and get a mentor', 'Keep using it', 'Ignore it'],
        correct: 1,
        explanation: 'If the blade breaks while you are operating it simply turn it off and send your partner to get a mentor.'
      }
    ]
  },
  {
    id: 'portable-drill',
    name: 'Portable Drill Safety',
    description: 'Safe operation of portable drills, bit selection, and drilling techniques',
    order: 8,
    safetyNotes: getSafetyNotesForSection('portable-drill'),
    questions: [
      {
        id: 'pd_001',
        section: 'portable-drill',
        type: 'multiple-choice',
        question: 'You ______ secure a piece of scrap wood to your worktable.',
        options: ['Should', 'Should not', 'Never', 'Sometimes'],
        correct: 0,
        explanation: 'Secure a piece of scrap wood and the good wood to the table so that it will not move around while drilling.'
      },
      {
        id: 'pd_002',
        section: 'portable-drill',
        type: 'multiple-choice',
        question: 'Make sure that the drill is switched ______ and that the work area is clean and dry BEFORE you plug the drill in and turn it ON!',
        options: ['On', 'Off', 'Auto', 'High'],
        correct: 1,
        explanation: 'Make sure that the switch is OFF, the chuck key is removed, and that your work area is clean and dry BEFORE you plug the drill in.'
      },
      {
        id: 'pd_003',
        section: 'portable-drill',
        type: 'multiple-choice',
        question: 'You ______ drill with straight, steady, even pressure.',
        options: ['Should', 'Should not', 'Never', 'Sometimes'],
        correct: 0,
        explanation: 'Drill with a straight, even, and steady pressure.'
      },
      {
        id: 'pd_004',
        section: 'portable-drill',
        type: 'multiple-choice',
        question: 'To provide for a SAFE and even drilling process, you need to clear the area as you drill. To do this you need to ______.',
        options: ['Stop drilling', 'Withdraw the drill bit several times', 'Change bits', 'Use water'],
        correct: 1,
        explanation: 'When drilling deep holes, withdraw the drill bit several times to clear the area. This helps to provide a SAFE and even drilling process.'
      }    ]
  },
  {
    id: 'drill-press',
    name: 'Drill Press Safety',
    description: 'Safe operation of drill presses, setup procedures, and drilling techniques',
    order: 9,
    safetyNotes: getSafetyNotesForSection('drill-press'),
    questions: [
      {
        id: 'dp_001',
        section: 'drill-press',
        type: 'multiple-choice',
        question: 'You ______ use a piece of scrap wood and a clamp or vise grip when using the drill press.',
        options: ['Should', 'Should not', 'Never', 'Sometimes'],
        correct: 0,
        explanation: 'Always use a piece of scrap wood and set the table or stop to keep from drilling into the tabletop. Use a clamp or vise grips to secure your wood to the table.'
      },
      {
        id: 'dp_002',
        section: 'drill-press',
        type: 'multiple-choice',
        question: 'Objects other than your wood and clamps ______ be removed from the table top because they can get caught in the machine and cause injuries.',
        options: ['Should', 'Should not', 'Never', 'Sometimes'],
        correct: 0,
        explanation: 'Make sure that your scrap wood, good wood, and any clamp you are using are the ONLY objects on the table. Other objects can get caught in the machine and cause injuries.'
      },
      {
        id: 'dp_003',
        section: 'drill-press',
        type: 'multiple-choice',
        question: 'The type of bit you select for drilling ______ important.',
        options: ['Is', 'Is not', 'Might be', 'Sometimes is'],
        correct: 0,
        explanation: 'Select the right size and type of bit. Wood bits for wood, metal bits for metal.'
      },
      {
        id: 'dp_004',
        section: 'drill-press',
        type: 'multiple-choice',
        question: 'You ______ use a center punch when drilling into metal or hard woods.',
        options: ['Should', 'Should not', 'Never', 'Sometimes'],
        correct: 0,
        explanation: 'Use a center punch for a guide whenever possible. Always use a center punch when drilling into metal or hard woods.'
      },
      {
        id: 'dp_005',
        section: 'drill-press',
        type: 'multiple-choice',
        question: 'You should use a ______ drill speed when drilling into metals, hard wood, and with larger drill bits.',
        options: ['Faster', 'Slower', 'Variable', 'High'],
        correct: 1,
        explanation: 'For metal or hard woods and large drill bits you should use a slower speed.'
      },
      {
        id: 'dp_006',
        section: 'drill-press',
        type: 'multiple-choice',
        question: '______ panic if the bit gets stuck in the wood, you should turn the machine off and when it has completely stopped, remove the bit from your wood.',
        options: ['Do', 'Do not', 'Always', 'Sometimes'],
        correct: 1,
        explanation: 'Do not panic if the bit gets stuck in the wood. Turn the machine off. When it has completely stopped, remove the bit from your wood.'
      },
      {
        id: 'dp_007',
        section: 'drill-press',
        type: 'multiple-choice',
        question: 'You should remove chips from the table with your ______.',
        options: ['Hand', 'Table broom', 'Fingers', 'Cloth'],
        correct: 1,
        explanation: 'Always remove the chips from the table after the machine is turned off and is no longer moving. Use a table brush, never your hands.'
      },
      {
        id: 'dp_008',
        section: 'drill-press',
        type: 'multiple-choice',
        question: 'Following safety procedures before operating this machine is ______.',
        options: ['Optional', 'Required', 'Unnecessary', 'Sometimes needed'],
        correct: 1,
        explanation: 'Multiple safety procedures must be followed before operating the drill press.'
      },
    ]
  },
  {
    id: 'soldering-station',
    name: 'Soldering Station Safety',
    description: 'Safe operation of soldering stations, heat safety, and burn prevention',
    order: 10,
    safetyNotes: getSafetyNotesForSection('soldering-station'),
    questions: [
      {
        id: 'ss_001',
        section: 'soldering-station',
        type: 'multiple-choice',
        question: '______ of the soldering equipment is hot when it is on.',
        options: ['Only the tip', 'All of', 'None of', 'Half of'],
        correct: 1,
        explanation: 'All of the soldering equipment is hot when it is on, and components remain hot for extended periods after being turned off.'
      },
      {
        id: 'ss_002',
        section: 'soldering-station',
        type: 'multiple-choice',
        question: 'The soldering equipment should be ______ after use.',
        options: ['In its holder', 'Laid on the bench', 'Left running', 'Thrown away'],
        correct: 0,
        explanation: 'Always place equipment back in holder after use. Never lay it on the bench. The soldering equipment should be in its holder after use.'
      },
      {
        id: 'ss_003',
        section: 'soldering-station',
        type: 'multiple-choice',
        question: '______ let any of the melted solder touch your skin.',
        options: ['It feels cool to', 'Do not', 'Always', 'Sometimes'],
        correct: 1,
        explanation: 'Do not let any of the melted solder touch your skin, as this can cause serious burns.'
      },
    ]
  }
];